import { render, staticRenderFns } from "./PropostaEditCredito.vue?vue&type=template&id=f6a3d02c"
import script from "./PropostaEditCredito.vue?vue&type=script&lang=js"
export * from "./PropostaEditCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports